const displayNamesCache = new Map<string, Intl.DisplayNames | null>()

const getDisplayNames = (language: string) => {
  if (!displayNamesCache.has(language)) {
    let displayNames: Intl.DisplayNames | null = null
    try {
      displayNames = new Intl.DisplayNames([language], { type: "region" })
    } catch {
      // Navegador sem Intl.DisplayNames: quem chama cai no nome de fallback.
    }
    displayNamesCache.set(language, displayNames)
  }
  return displayNamesCache.get(language) ?? null
}

/**
 * Nome do país no idioma informado, a partir do ISO alpha-2 (via Intl.DisplayNames,
 * sem manter uma lista por idioma). Usa o fallback quando o navegador não resolve.
 */
export const getCountryName = (iso: string, language: string, fallback: string) => {
  const name = getDisplayNames(language)?.of(iso.toUpperCase())
  return name && name !== iso.toUpperCase() ? name : fallback
}
